module.exports = __webpack_public_path__ + "static/img/invest-consume6.11558c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume6.jpg
// module id = AD/a
// module chunks = 0